import { CircularProgress } from "@mui/material";
import { get } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import listingOperations from "../listing/ducks/operations";
import searchOperations from "../search/ducks/operations";
import utilOperations from "../utils/operations";
import operations from "./ducks/operations";
import PropertyDetail from "./PropertyDetail";

const PropertyDetailContainer = (props) => {
    const { clearPageState, getProperty, isLoading, propertyManagement } = props;
    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (id) {
            handleGetProperty();
        }
        ReactGA.send({ hitType: "pageview", page: "/propdetail/*", title: `Property Detail: ${id}` });
        return () => {
            clearPageState();
        };
    }, []);

    const handleGetProperty = async () => {
        const response = await getProperty(id, true);
        if (!response?.success) {
            navigate("/properties");
        }
    };
    if (isLoading) {
        return (
            <div style={{ textAlign: "center", verticalAlign: "center" }}>
                <CircularProgress style={{ position: "absolute", top: "50%" }} color="primary" />
            </div>
        );
    } else {
        return (
            <PropertyDetail
                {...props}
                propertyKey={id}
                hasPortfolioProperties={get(propertyManagement, "assetPortfolioProperties", []).length > 0}
            />
        );
    }
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        property: state.propertyReducer.property,
        images: state.propertyReducer.images,
        propertyType: state.propertyReducer.property.propertyType,
        isLoading: state.utilsReducer.isLoading,
        tab: state.propertyReducer.propertyDetailTab ? state.propertyReducer.propertyDetailTab : "property",
        listings: get(state, "listingReducer.listings.property_listings", []),
        compHistory: get(state, "compReducer.comps.comp_history_for_property", []),
        propertyManagement: state.propertyReducer.propertyManagement,
        propertyManagementSnapshots: state.propertyReducer.propertyManagementSnapshots,
        autocompleteResults: state.searchReducer.autocompleteResults,
        errors: state.utilsReducer.errors,
        elementsSaving: state.utilsReducer.elementsSaving,
        requestModal: state.listingReducer.requestModal,
        personnelInfo: state.propertyReducer.propertyManagement.personnelInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProperty: (propKey, loadImages) => {
            return dispatch(operations.getPropertyDetail(propKey, loadImages));
        },
        switchTab: (_, value) => {
            dispatch(operations.switchPropDetailTab(value));
        },
        closeDeal: (listing) => {
            return dispatch(listingOperations.closeDeal(listing));
        },
        getFlyer: (listingKey) => {
            dispatch(listingOperations.getFlyer(listingKey));
        },
        navigateToRequestUpdate: (listingKey, redirectTo) => {
            dispatch(listingOperations.navigateToRequestUpdate(listingKey, redirectTo));
        },
        navigateToRequestPropertyUpdate: (listingKey, redirectTo) => {
            dispatch(operations.navigateToRequestPropertyUpdate(listingKey, redirectTo));
        },
        toggleRequestModal: (spaceType, transactionType) => {
            dispatch(listingOperations.toggleRequestModal(spaceType, transactionType));
        },
        updateSearchTerm: (value, searchType) => {
            dispatch(searchOperations.updateFilter("searchTerm", value, searchType));
        },
        handleSearchSubmit: () => {
            dispatch(searchOperations.executeSearch("property_modal"));
            dispatch(searchOperations.storeSearchRun(true, "property_modal".toUpperCase()));
        },
        addPropertyManagementSection: (key) => {
            dispatch(operations.addPropertyManagementSection(key));
        },
        handleAddArrayElement: (arrayPath) => {
            dispatch(operations.addArrayElement(arrayPath));
        },
        handleDeleteArrayElement: (arrayPath, index) => {
            dispatch(operations.deleteArrayElement(arrayPath, index));
        },
        handleUpdateArrayElement: (arrayPath, index, field, value) => {
            dispatch(operations.handleInputChange(arrayPath + "[" + index + "]." + field, value));
        },
        clearErrorByField: (field) => {
            dispatch(utilOperations.clearErrorByField(field));
        },
        handleInput: (field, value) => {
            dispatch(operations.handleInputChange(field, value));
        },
        savePropertyManagementDetails: (key) => {
            dispatch(operations.savePropertyManagementDetails(key));
        },
        searchKMPerson: (term) => {
            dispatch(searchOperations.searchKMPersonAutocomplete(term));
        },
        addListingGivenProperty: async (property, useType, transactionType, navigate) => {
            const result = await dispatch(
                listingOperations.addListingGivenProperty(property, useType, transactionType)
            );

            if (result?.listingKey) {
                navigate(`/listing/${result.listingKey}`);
            }
        },
        clearPageState: () => {
            dispatch(listingOperations.clearTabContents("property_listings"));
            dispatch(operations.clearPropertyDetailState());
        },
        handleSearchCompany: (inputValue, companyType) => {
            dispatch(searchOperations.searchCompany(inputValue, companyType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyDetailContainer);
